import { Component, OnInit, Input, Output } from '@angular/core';
import { ConstantsService } from '../../../_services/constants.service';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { OperationsService } from 'src/app/_services';


@Component({
  selector: 'app-documentsmodal',
  templateUrl: './documentsmodal.component.html',
  styleUrls: ['./documentsmodal.component.css']
})
export class DocumentsmodalComponent implements OnInit {
  @Input('request_id') request_id: any;
  @Input('token') token: any;
  attachments: any = [];
  view: any = 'documents';
  documents: any = [];
  pictures: any = [];

  constructor(
    private http: HttpClient,
    private constant: ConstantsService,
    private operationsService: OperationsService
  ) {
  }

  ngOnInit() {
    
    return this.getAttachments()
  }

  documentChecked() {
    this.view = 'documents'
  }

  photoChecked() {
    this.view = 'pictures'
  }

  getAttachments() {
    return this.http.post<any>(`${this.constant.read('api_loan')}loan/attachments`, {
      request_id: this.request_id,
      token: this.token
    }).subscribe(response => {
      if (response.status) {
        this.attachments = response.data;
      }
    }, error => {
      //console.log(error);
    })
  }
}
